<template>
  <div class="relative w-full">
    <img
      class="absolute inset-y-1.5 left-3 h-5 w-auto top-0 bottom-0 my-auto"
      :src="icon"
      alt=""
    />
    <input
      type="text"
      v-model="valueMutable"
      class="block w-full pl-12 pr-2 text-white outline-none bg-block-2 text-sm py-3.5 rounded"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default {
  name: "InputIcon",
  props: {
    modelValue: {
      type: [String, Number]
    },
    icon: {
      type: String,
      default: "/svg/search.svg"
    },
    placeholder: {
      type: String
    }
  },

  computed: {
    valueMutable: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  }
}
</script>